module.exports = __webpack_public_path__ + "h5/img/home13.742844f7.png";